export const Config = {
  StaticResourcesBucketURL: 'https://storage.googleapis.com/atria-static-resources',
  newDefaultColor: true,
};
